import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const recipesV2AccessControl: DomainAccessControlConfig = {
  // Temporarily use Admin permission for development/testing
  // TODO: Switch to [Permission.RecipesV2View] once backend permissions are created
  permissions: [Permission.Admin],
  // Set high to prevent prod visibility until ready
  minICPlatformVersion: ICPlatformVersion.r2026_12_0,
}

// For edit/create/delete routes (future use)
export const recipesV2ModifyAccessControl: DomainAccessControlConfig = {
  // Temporarily use Admin permission for development/testing
  // TODO: Switch to [Permission.RecipesV2Modify] once backend permissions are created
  permissions: [Permission.Admin],
  minICPlatformVersion: ICPlatformVersion.r2026_12_0,
}
